import { ChangeDetectionStrategy, Component, OnInit, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { UiModule } from 'src/app/ui/ui.module';
import { IconService } from 'src/app/ui/icon.service';
import { ChartData, ChartOptions } from 'chart.js';
import { FinanceService } from 'src/app/api/finance.service';
import { BaseChartDirective } from 'ng2-charts';
import { Overpayment } from 'src/app/api/commonInterfaces';
import { Column, TableColumnsComponent } from 'src/app/ui/tables';
import { TableHeadersComponent } from 'src/app/ui/tables';
import { TableCaptionComponent } from 'src/app/ui/tables';
import { MessageService } from 'primeng/api';
import { LocalAuthService } from 'src/app/auth/local-auth.service';

@Component({
  selector: 'app-overpayments-graph',
  standalone: true,
  imports: [CommonModule, FormsModule, CardModule, UiModule, TableColumnsComponent, TableHeadersComponent, TableCaptionComponent],
  templateUrl: './overpayments-graph.component.html',
  styleUrl: './overpayments-graph.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverpaymentsGraphComponent implements OnInit {

  isLoading = signal<boolean>(true);
  overpayments = signal<Overpayment[]>([]);
  detailsDialogVisible = false
  dialogLoading = signal<boolean>(false);

  january = new Date(2025, 0, 1);
  today = new Date();

  tableColumns: Column<Overpayment>[] = [
    { field: 'tripID', header: 'Trip ID', type: 'tripIdWithLink', custIdField: 'custID', sortable: true, filterable: true, tripIdField: 'tripID', fragment: 'payments' },
    {field: 'consultantName', header: 'Consultant Name', type: 'text', sortable: true, filterable: true },
    {field: 'customerGroup', header: 'Group Name', type: 'text', sortable: true, filterable: true },
    {field: 'leaderName', header: 'Leader Name', type: 'text', sortable: true, filterable: true },
    {field: 'destination', header: 'Location', type: 'text', sortable: true, filterable: true },
    {field: 'tripDate', header: 'Trip Date', type: 'date', sortable: true, filterable: true },
    {field: 'overpaymentAmount', header: 'Balance', type: 'currency', sortable: true, filterable: true },
  ]

  // Computed values for summary stats
  totalOverpayments = computed(() => {
    const data = this.overpayments();
    return data.reduce((sum, overpayment) => sum + (overpayment.overpaymentAmount || 0), 0);
  });

  countOverpayments = computed(() => {
    return this.overpayments().length;
  });


  constructor(
    private financeService: FinanceService,
    private messageService: MessageService,
    public authService: LocalAuthService,
    public icons: IconService,
  ) { }

  ngOnInit(): void {
    this.getOverpayments();
  }

  getOverpayments() {
    console.log(this.january, this.today);
    this.financeService.getOverpayments(this.january, this.today)
      .subscribe({
        next: (data) => {
          this.overpayments.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          this.isLoading.set(false);
          this.messageService.add({severity:'error', summary: 'Error', detail: 'Error fetching overpayments data, error: ' + err.message, life: 5000});
        }
      });
  }

  showDetailsDialog() {
    this.detailsDialogVisible = true;
  }

}